import { getValuableVariables } from '@anytag/shared-utils';
import { useFacebookPageAnalyticsOverviewQuery } from '@anytag/graphql';
import { useQueryHelper } from '@anytag/shared-hooks';
import { AnalyticsSelectedAccountInfo } from '../../../types';
import { useAnalyticsProfileSearch } from '../../../hooks';
import { AnalyticsFacebookDashboardOverviewTemplate } from './AnalyticsFacebookDashboardOverviewTemplate';

export interface AnalyticsFacebookDashboardOverviewProps {
  analyticsAccount: AnalyticsSelectedAccountInfo;
}

export const AnalyticsFacebookDashboardOverview = ({ analyticsAccount }: AnalyticsFacebookDashboardOverviewProps) => {
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const { filter } = useAnalyticsProfileSearch();

  const { data, loading } = useFacebookPageAnalyticsOverviewQuery({
    fetchPolicy: 'no-cache',
    variables: getValuableVariables({
      endDate: filter.endDate,
      startDate: filter.startDate,
      facebookPageAnalyticsAccountId: analyticsAccount.id
    }),
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
      navigate({ to: '/analytics' });
    }
  });

  return (
    <AnalyticsFacebookDashboardOverviewTemplate
      loading={loading}
      accountId={analyticsAccount.id}
      data={data?.facebookPageAnalyticsOverview}
    />
  );
};
